import type { DmDoctorForm, DmFormErrors } from './dmForms.ts';
import { DmLocaleSelect } from './DmLocaleSelect';
import { DmTextField } from './DmTextField';

interface DmDoctorFormFieldsProps {
    form: DmDoctorForm;
    onChange: (next: DmDoctorForm) => void;
    errors: DmFormErrors;
}

export function DmDoctorFormFields({ form, onChange, errors }: DmDoctorFormFieldsProps) {
    const text = (key: Exclude<keyof DmDoctorForm, 'locale'>) => ({
        value: form[key],
        onChange: (next: string) => onChange({ ...form, [key]: next }),
        error: errors[key]
    });

    return (
        <div className="grid grid-cols-2 gap-3">
            <DmTextField label="First name" {...text('firstname')} />
            <DmTextField label="Last name" {...text('lastname')} />
            <div className="col-span-2">
                <DmTextField label="Email" type="email" {...text('email')} />
            </div>
            <DmTextField label="Phone" placeholder="+15551234567" {...text('phone')} />
            <DmLocaleSelect
                value={form.locale}
                onChange={(locale) => onChange({ ...form, locale })}
            />
        </div>
    );
}
